import LegalPage from "@/components/LegalPage";
import { BUSINESS } from "@/config/business";

export default function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy">
      <p>
        This Privacy Policy explains how {BUSINESS.legalName} (&ldquo;
        {BUSINESS.brandName},&rdquo; &ldquo;we,&rdquo; &ldquo;us,&rdquo; or
        &ldquo;our&rdquo;) collects, uses, and shares information when you visit{" "}
        {BUSINESS.domain} (the &ldquo;Site&rdquo;) or submit an inquiry through
        our assessment form. By using the Site, you agree to the practices
        described here.
      </p>

      <h2>1. Information we collect</h2>
      <p>We collect information you provide directly, including:</p>
      <ul>
        <li>
          <strong>Contact details</strong> — your name, phone number, and email
          address.
        </li>
        <li>
          <strong>Business information</strong> — your business name, estimated
          total merchant cash advance (MCA) debt, number of active positions,
          and related details you choose to share.
        </li>
        <li>
          <strong>Communications</strong> — records of your interactions with us
          by phone, text, email, or web form.
        </li>
      </ul>
      <p>
        We also automatically collect limited technical data such as your IP
        address, browser type, device information, referring pages, and usage
        activity through cookies and similar technologies.
      </p>
      <p>
        Our assessment form is provided through Jotform, a third-party form
        provider. Information you submit through the form is processed by
        Jotform on our behalf and is also subject to Jotform&rsquo;s privacy
        practices.
      </p>

      <h2>2. How we use your information</h2>
      <ul>
        <li>To respond to your inquiry and contact you about your situation.</li>
        <li>
          To review your MCA positions and discuss consolidation or
          restructuring options.
        </li>
        <li>To operate, maintain, and improve the Site and our services.</li>
        <li>
          To comply with legal obligations and enforce our Terms of Service.
        </li>
      </ul>

      <h2>3. Telephone, text, and email consent</h2>
      <p>
        By submitting your information, you expressly consent to be contacted by
        {" "}
        {BUSINESS.brandName} and its representatives by phone call, text/SMS
        message, or email at the number and address you provide, including
        through automated technology, for the purpose of responding to your
        inquiry. Consent is not a condition of any purchase. Message and data
        rates may apply. You may opt out at any time by replying STOP to a text,
        or by contacting us at {BUSINESS.privacyEmail}.
      </p>

      <h2>4. How we share information</h2>
      <p>We do not sell your personal information. We may share it with:</p>
      <ul>
        <li>
          <strong>Your funders / lenders</strong>, where necessary and with your
          authorization, to explore consolidation or restructuring options on
          your behalf.
        </li>
        <li>
          <strong>Service providers</strong> (such as our form, hosting,
          analytics, and communications vendors) who process data on our behalf.
        </li>
        <li>
          <strong>Legal and safety</strong> recipients when required by law,
          subpoena, or to protect our rights, users, or the public.
        </li>
        <li>
          <strong>Business transfers</strong>, in connection with a merger,
          acquisition, or sale of assets.
        </li>
      </ul>

      <h2>5. Cookies and analytics</h2>
      <p>
        We use cookies and similar technologies to understand how visitors use
        the Site and to measure the performance of our marketing. You can
        control cookies through your browser settings. If we run advertising
        campaigns, third-party partners may set cookies to measure conversions.
      </p>

      <h2>6. Data retention and security</h2>
      <p>
        We retain your information for as long as needed to provide our services
        and to comply with our legal obligations. We use reasonable
        administrative, technical, and physical safeguards to protect your
        information. No method of transmission or storage is completely secure,
        and we cannot guarantee absolute security.
      </p>

      <h2>7. Your privacy rights</h2>
      <p>
        Depending on where you live, you may have the right to access, correct,
        delete, or restrict the use of your personal information, and to opt out
        of certain sharing. To exercise these rights, contact us at{" "}
        {BUSINESS.privacyEmail}. We will respond as required by applicable law.
      </p>

      <h2>8. Children&rsquo;s privacy</h2>
      <p>
        The Site is intended for business owners and is not directed to
        individuals under 18. We do not knowingly collect information from
        children.
      </p>

      <h2>9. Changes to this policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Changes are
        effective when posted, and the &ldquo;Last updated&rdquo; date above
        reflects the most recent revision.
      </p>

      <h2>10. Contact us</h2>
      <p>
        {BUSINESS.legalName}
        <br />
        {BUSINESS.addressLine}, {BUSINESS.cityStateZip}
        <br />
        Email: <a href={`mailto:${BUSINESS.privacyEmail}`}>{BUSINESS.privacyEmail}</a>
        <br />
        Phone: <a href={BUSINESS.phoneHref}>{BUSINESS.phoneDisplay}</a>
      </p>
    </LegalPage>
  );
}
